exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".article-summary-container{padding:25px 0 50px 0}.article-summary-container .section-title{display:flex;justify-content:center;padding:25px 0 34px 0}.article-summary-container .section-title h2{font-size:30px;font-weight:500;line-height:36px;letter-spacing:.23px}@media(min-width: 576px){.article-summary-container .section-title h2{text-align:center}}@media(max-width: 575px){.article-summary-container .section-title h2{text-align:center}}.article-summary-container .section-content-container{display:flex;justify-content:center}.article-summary-container .section-content-container .section-content{display:flex;gap:30px}@media screen and (max-width: 1054px){.section-content{flex-direction:column}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/LandingPages/SolutionsArticleSummary/SolutionArticleSummary.scss
// module id = 7943
// module chunks = 13